export default __webpack_public_path__ + "static/media/call-phone.63f52386.svg";